<template>
  <v-app class="primary--text">
    <!-- Drawer -->
    <v-navigation-drawer
            v-model="drawer"
            class="secondary"
            fixed
            app
            right
            v-if="$vuetify.breakpoint.smAndDown"
    >

      <v-toolbar color="primary" dark flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              Menu
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider/>
      <v-list dense>
        <v-list-tile v-for="item in menu" :key="item.name" :to="{name: item.name}" >
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-center">{{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <!-- Toolbar -->
    <v-toolbar :color="scrolled ? 'primary' : 'rgba(0,0,0,0.5)'" dark fixed class="secondary--text">
      <v-toolbar-title class="px-2">{{who}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <template v-for="item in menu">
          <v-btn exact flat :to="{name: item.name}" active-class="" exact-active-class="v-btn--active" :key="item.name"
                 v-if="!item.menu">
            {{item.title}}
          </v-btn>
          <v-menu top :key="item.name" v-else>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" flat>
                {{item.title}}
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                      v-for="subitem in item.menu"
                      :key="subitem.name"
                      :to="{name: item.name, hash: '#' + subitem.name}"
              >
                <v-list-tile-title>{{ subitem.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </template>
      </v-toolbar-items>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
    </v-toolbar>
    <!-- Content -->
    <v-content>
      <transition-slide-up-down>
        <router-view/>
      </transition-slide-up-down>
    </v-content>
  </v-app>
</template>

<script>


  import TransitionSlideUpDown from "@/components/TransitionSlideUpDown";
  import {mapGetters} from "vuex";
  import scrollMixin from "@/mixins/scrollMixin";

  export default {
    name: 'App',
    mixins: [scrollMixin],
    components: {TransitionSlideUpDown},
    data() {
      return {
        drawer: false
      }
    },
    computed: {
      ...mapGetters(['who', 'menu']),
      scrolled() {
        return this.$data.scrollOffset > 0 ;
      }
    },
  }
</script>
<style lang="stylus">
  @import "~@/assets/stylus/main.styl";
</style>
